module.exports = __webpack_public_path__ + "db38b3d98f170a79d4c30893e4e460a3.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-1024.webp
// module id = 464
// module chunks = 0